import Cookies from 'js-cookie'

export default () => {
  const modal = document.querySelectorAll('.modal');
  const close_modal = document.querySelectorAll('.close_modal');
  const important_notification_modal = document.getElementById('important_notification_modal');

  // if (typeof Cookies.get('important_showed') === "undefined") {
  //   important_notification_modal.classList.remove('hidden');
  // }

  if (close_modal.length) {
    $(document).keyup(function(e) {
      if (e.key === "Escape") {
        $('body').removeClass("no-scroll");
        $('.modal').removeClass('is-open');
      }
    });
  }

  close_modal.forEach((el) => {
    el.addEventListener('click', (e) => {
      const days_to_not_show = e.currentTarget.dataset.days;

      modal.forEach((el) => {

        $('body').removeClass("no-scroll");
        $('.modal').removeClass('is-open');

      });

      if (typeof days_to_not_show !== "undefined") {
        Cookies.set('important_showed', '1', { expires: Number(days_to_not_show), path: '/' });
        important_notification_modal.classList.add('hidden');
      }
    });
  });

  const links = document.querySelectorAll('a');

  links.forEach((el) => {
    el.addEventListener('click', (e) => {
      if (e.target.getAttribute('href') === '#aplikuoti') {
        const modal_aplikuoti = document.querySelector('.modal_aplikuoti');
        const body = document.getElementsByTagName('body')[0];

        e.preventDefault();

        body.classList.add('no-scroll');
        modal_aplikuoti.classList.add('is-open');
      }
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/modals.js